<!-- 智能优惠券功能 -->
<template>
    <div>
        <!--智能优惠券-->
        <a-modal width="1100px" v-model="autoCouponShow" :title="$t('message.strategyPushMgt.SmartCoupons')" :maskClosable="false" @cancel="handleCancel">
           
            <template slot="footer">
                <a-button  :size="$globalSize"  type="primary" @click="backToStrategy"> {{ $t('message.commonUsage.previous') }} </a-button>
                <a-button  :size="$globalSize"  type="primary" @click="couponNext2"> {{ $t('message.commonUsage.next') }} </a-button>
            </template>
            <a-card>
                <a-row  :gutter="[16, 16]">
                    <a-col :span="3"><span class="title-name"><span class="coupon-required-text"></span>{{ $t('message.strategyManagement.filterRuleCol2') }}
                        <a-tooltip placement="topLeft" arrow-point-at-center>
                            <template slot="title">
                              {{ $t('message.strategyPushMgt.productQuantity3510') }}
                            </template>
                            <a-icon type="question-circle" />
                        </a-tooltip>
                    ：</span></a-col>
                    <a-col :span="7"><span class="title-name">{{ $t('message.strategyPushMgt.product') }}</span></a-col>
                    <a-col :span="7"><span class="title-name ml40">{{ $t('message.strategyPushMgt.Importance') }}</span></a-col>
                    <a-col :span="7"><span class="title-name">{{ $t('message.strategyPushMgt.CoveredCategories') }}</span> </a-col>
                </a-row>

                <a-row  :gutter="[16, 16]" >
                    <a-col :span="3"></a-col>
                    <a-col :span="7">
                        <a-checkbox-group v-model="autoProductTargetObj.productType" @change="productTypeChange">
                            <a-checkbox v-for="item in productsTypeList" :key="item.id" :style="productRadioStyle"
                                :value="item">{{ item.value }}</a-checkbox>
                        </a-checkbox-group>
                    </a-col>
                    <a-col :span="7" class="mid">
                        <a-radio-group :size="$globalSize" :disabled="disableContent1" v-model="autoProductTargetObj.important1" button-style="solid">
                            <a-radio-button v-for="item in importantOptions" :key="item.id" :value="item.key">{{item.value}}</a-radio-button>
                        </a-radio-group>

                        <a-radio-group :size="$globalSize" :disabled="disableContent2" v-model="autoProductTargetObj.important2" button-style="solid">
                            <a-radio-button v-for="item in importantOptions" :key="item.id" :value="item.key">{{item.value}}</a-radio-button>
                        </a-radio-group>

                        <a-radio-group :size="$globalSize" :disabled="disableContent3" v-model="autoProductTargetObj.important3" button-style="solid">
                            <a-radio-button v-for="item in importantOptions" :key="item.id" :value="item.key">{{item.value}}</a-radio-button>
                        </a-radio-group>

                        <a-radio-group :size="$globalSize" :disabled="disableContent4" v-model="autoProductTargetObj.important4" button-style="solid">
                            <a-radio-button v-for="item in importantOptions" :key="item.id" :value="item.key">{{item.value}}</a-radio-button>
                        </a-radio-group>
                    </a-col>
                    <a-col :span="7" class="mid">
                        <a-select :size="$globalSize" :disabled="disableContent1" mode="multiple" allowClear :maxTagCount="1" v-model="autoProductTargetObj.categoryCovered1"
                            style="width: 180px" @change="e=>changeCategoryCovered(e,1)">
                            <a-select-option v-for="item in categoryCoveredOptions" :key="item.key">
                                {{ item.value }}
                            </a-select-option>
                        </a-select>
                        <br />
                        <a-select :size="$globalSize" :disabled="disableContent2" mode="multiple" allowClear :maxTagCount="1" v-model="autoProductTargetObj.categoryCovered2"
                            style="width: 180px" @change="e=>changeCategoryCovered(e,2)">
                            <a-select-option v-for="item in categoryCoveredOptions" :key="item.key">
                                {{ item.value }}
                            </a-select-option>
                        </a-select>
                        <br />

                        <a-select :size="$globalSize" :disabled="disableContent3" mode="multiple" allowClear :maxTagCount="1" v-model="autoProductTargetObj.categoryCovered3"
                            style="width: 180px" @change="e=>changeCategoryCovered(e,3)">
                            <a-select-option v-for="item in categoryCoveredOptions" :key="item.key">
                                {{ item.value }}
                            </a-select-option>
                        </a-select>
                        <br />

                        <a-select :size="$globalSize" :disabled="disableContent4" mode="multiple" allowClear :maxTagCount="1" v-model="autoProductTargetObj.categoryCovered4"
                            style="width: 180px" @change="e=>changeCategoryCovered(e,4)">
                            <a-select-option v-for="item in categoryCoveredOptions" :key="item.key">
                                {{ item.value }}
                            </a-select-option>
                        </a-select>
                    </a-col>
                </a-row>

             
                <a-row :gutter="[16, 16]">
                    <a-col :span="3"><span class="title-name"><span class="coupon-required-text">*</span>{{ $t('message.strategyPushMgt.PrimaryTargets') }}
                        <a-tooltip placement="topLeft" arrow-point-at-center>
                            <template slot="title">
                              {{ $t('message.strategyPushMgt.tips1') }}
                            </template>
                            <a-icon type="question-circle" />
                        </a-tooltip>
                    :</span></a-col>
                    <a-col :span="21">
                        <a-radio-group :size="$globalSize" v-model="autoProductTargetObj.chiefAim">
                            <a-radio :style="radioStyle" v-for="item in chiefAimOptions" :key="item.value" :value="item.value"> {{ item.name }} </a-radio>
                        </a-radio-group>
                    </a-col>
                 
                </a-row>
                <a-row :gutter="[16, 16]">
                    <a-col :span="3"><div class="title-name mt6"><span class="coupon-required-text"></span>{{ $t('message.strategyPushMgt.OtherTargets') }}
                        <a-tooltip placement="topLeft" arrow-point-at-center>
                            <template slot="title">{{ $t('message.strategyPushMgt.tips2') }}</template>
                            <a-icon type="question-circle" />
                        </a-tooltip>
                    :</div></a-col>
                    <a-col :span="21">
                        <a-checkbox-group v-model="autoProductTargetObj.otherAim" @change="otherAimChange">
                            <!-- <a-checkbox :style="radioStyle" :value="1">多样性提升</a-checkbox> -->
                            <a-checkbox :style="radioStyle" :value="2">{{ $t('message.strategyPushMgt.AvoidCouponsPushed') }}</a-checkbox>
                        </a-checkbox-group>
                        <a-input-number :size="$globalSize" v-model='autoProductTargetObj.otherAimPush'/> &nbsp;&nbsp; 次之后就不继续推送该优惠券
                    </a-col>
                </a-row>
            </a-card>
        </a-modal>
        
        <!-- 产品页 -->
        <a-modal width="1000px" class="modal-product" v-model="autoCouponShow2" :title="$t('message.strategyPushMgt.ProductPage')" :maskClosable="false" @cancel="handleCancel">
            <template slot="footer">
                <a-spin :spinning="spinningProductPage">
                  <a-button  :size="$globalSize"  @click="autoCouponShow2 = false; autoCouponShow = true"> {{$t('message.commonUsage.previous')}} </a-button>
                  <a-button  :size="$globalSize"  type="primary" @click="savaAutoCouponProductConfig" :loading="loading_coupon"> {{$t('message.commonUsage.save')}} </a-button>
                </a-spin>
            </template>
            <a-spin :spinning="spinningProductPage" :tip="$t('message.strategyPushMgt.BatchImportting')">
            <a-row :gutter="[16, 16]">
                <a-col :span="4"><span class="title-name"><span class="coupon-required-text"></span>{{ $t('message.strategyPushMgt.ProductAdjustment') }}
                    <a-tooltip placement="topLeft" arrow-point-at-center>
                        <template slot="title">
                            非必选项，选择相应的产品，调整该产品与用户的匹配度。可选择多个产品进行调整。
                        </template>
                        <a-icon type="question-circle" />
                    </a-tooltip>
                :</span></a-col>
                <a-col :span="20">
                    <div class="inline-block">
                        <span class="title-name pr20">{{ $t('message.strategyPushMgt.ProductSelection') }}&nbsp;&nbsp;&nbsp;&nbsp; </span>
                       
                        <a-button  :size="$globalSize"  class="edit-btn" type="primary"   @click="productControl"> {{$t('message.commonUsage.edit')}} </a-button>
                    </div>
                   <!--<span class="title-name">结果列表</span>--> 
                    <a-table class="product-table" :pagination="productPage" row-key="id" :columns="resultcolumnsProduct" :data-source="productResultData" />
                </a-col>
            </a-row>
            <a-row :gutter="[16, 16]">
                <a-col :span="4"><span class="title-name"><span class="coupon-required-text"></span>{{ $t('message.strategyPushMgt.CouponQuantityControl') }}
                    <a-tooltip placement="topLeft" arrow-point-at-center>
                        <template slot="title">
                            非必选项，选择优惠券设置该策略下推送优惠券的人数限制。可选择多张优惠券进行人数限制。
                        </template>
                        <a-icon type="question-circle" />
                    </a-tooltip>
                :</span></a-col>
                <a-col :span="20">
                    <div class="inline-block">
                        <span class="title-name pr20">{{ $t('message.strategyPushMgt.CouponSelection') }}</span>
                        <div>
                            <a-button  :size="$globalSize"  class="edit-btn mr10" type="primary"  @click="productNumControl"> {{$t('message.commonUsage.edit')}} </a-button>
                            <a-button  :size="$globalSize"  class="edit-btn mr10" type="primary" icon="download"  @click="downloadTemplate"> {{ $t('message.strategyPushMgt.DownloadTemplate') }} </a-button>
                            <a-upload
                                accept=".xlsx, .xls"
                                name="file"
                                :fileList="[]"
                                :multiple="false"
                                action="#"
                                :customRequest="customRequest"
                            >
                                <a-button  :size="$globalSize"  class="edit-btn" type="primary" icon="upload" > {{ $t('message.strategyPushMgt.BatchImport') }} </a-button>
                            </a-upload>
                        </div>
                    </div>
                  <!--  <span class="title-name">结果列表</span>--> 
                    <a-table class="product-table" :pagination="productPage" row-key="coupon_id" :columns="resultcolumnsCoupon" :data-source="couponNumResultData">
                        <template slot="number" slot-scope="text,record">
                            {{text}} 张/{{record.data_type}}
                        </template>
                    </a-table>
                </a-col>
            </a-row>
            <a-row :gutter="[16, 16]">
                <a-col :span="4"><span class="title-name"><span class="coupon-required-text"></span>{{ $t('message.strategyPushMgt.MinimumDiscountCoupon') }}
                    <a-tooltip placement="topLeft" arrow-point-at-center>
                        <template slot="title">
                            非必选项，当存在没有匹配到优惠券或者被优惠券数量控制所限制用户，将会给塞保底券。如果选择多张券，则使用选中的多张保底券在进行计算得出最匹配用户的券。
                        </template>
                        <a-icon type="question-circle" />
                    </a-tooltip>
                :</span></a-col>
                <a-col :span="20">
                    <div class="inline-block">
                        <span class="title-name pr20">{{$t('message.strategyPushMgt.CouponSelection')}}  </span>
                        <a-button  :size="$globalSize"  class="edit-btn" type="primary"  @click="couponBaseEdit"> {{$t('message.commonUsage.edit')}}  </a-button>
                    </div>
                   <!--   <span class="title-name">结果列表</span>--> 
                    <a-table class="product-table" row-key="coupon_id" :pagination="productPage" :columns="couponResultColumns" :data-source="couponBaseResultData"></a-table>
                </a-col>
            </a-row>
          </a-spin>
        </a-modal>


        <!-- 产品调整 -->
        <a-modal width="800px" v-model="productShow" :cancelText="$t('message.commonUsage.cancel')" :okText="$t('message.commonUsage.confirm')" :title="$t('message.strategyPushMgt.ProductAdjustment')" :maskClosable="false" @ok="productAdjustOk">
            <a-row :gutter="[16, 16]">
                <a-col :span="4"><span class="title-name"><span class="coupon-required-text">*</span>{{ $t('message.strategyPushMgt.ProductSelection') }}:</span></a-col>
                <a-col :span="20">
                    <a-input-search class="search_input_style" :placeholder="$t('message.strategyPushMgt.searchNameOrID')" v-model="search_product_input" />
                    <a-table row-key="level_3_code" :columns="productColumns" :data-source="productTableData" :pagination="numPagination"
                        :row-selection="{ selectedRowKeys: productrowSelection, onChange: onSelectChangeProduct }"
                        bordered />
                </a-col>
            </a-row>
            <a-row :gutter="[16, 16]">
                <a-col :span="4"><span class="title-name"><span class="coupon-required-text">*</span>{{ $t('message.strategyPushMgt.EditContent') }}:</span></a-col>
                <a-col :span="4">
                    <a-radio-group :size="$globalSize" v-model="productAdjustObj.modifyRadio">
                        <a-radio :style="radioStyle" v-for="item in modifyOptions" :key="item.value" :value="item.value">{{item.name}}</a-radio>
                    </a-radio-group>
                </a-col>
                <a-col :span="4">
                    <div :style="radioStyle">
                        <a-select :size="$globalSize" allowClear  default-value="" style="width: 120px" v-model="productAdjustObj.fixedPosition">
                            <a-select-option v-for="item in fixedPositionOptions" :key="item.value" :value="item.value">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </div>
                    
                    <div :style="radioStyle">
                        <a-select :size="$globalSize" allowClear  default-value="" style="width: 120px" v-model="productAdjustObj.promotePosition">
                            <a-select-option v-for="item in promoteOptions" :key="item.value" :value="item.value">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </div>

                    <div :style="radioStyle">
                        <a-select :size="$globalSize" allowClear  default-value="" style="width: 120px" v-model="productAdjustObj.reducePosition">
                            <a-select-option v-for="item in reduceOptions" :key="item.value" :value="item.value">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </div>

                    <!-- <div :style="radioStyle">
                        <a-input-number :size="$globalSize" style="width: 120px"  :min="-5" :max="5" :step="1"
                            :formatter="value => `${value}`" v-model="productAdjustObj.modifyValue" />    
                    </div> -->
                </a-col>
            </a-row>
            <a-row :gutter="[16, 16]">
                <a-col :span="4"><span class="title-name"><span class="coupon-required-text">*</span>{{ $t('message.strategyPushMgt.UsageRange') }}:</span></a-col>
                <a-col :span="20">
                    <a-select :size="$globalSize" :maxTagCount="2" mode="multiple" style="width: 370px" v-model="productAdjustObj.usedScope">
                        <a-select-option v-for="item in productsTypeList" :key="item.id" :value="item.key">
                            {{ item.value }}
                        </a-select-option>
                    </a-select>
                </a-col>
            </a-row>
        </a-modal>

        <!-- 产品数量控制 -->
        <a-modal width="860px" :cancelText="$t('message.commonUsage.cancel')" :okText="$t('message.commonUsage.confirm')" v-model="couponNumShow" :title="$t('message.strategyPushMgt.CouponQuantityControl')" :maskClosable="false"
            @ok="couponNumOk">
            <a-row>
                <a-col :span="2"></a-col>
                <span class="title-name">{{ $t('message.strategyPushMgt.QueryCoupons') }}: &nbsp;&nbsp;&nbsp;&nbsp;</span>
                <a-input-search class="search_input_style" v-model="search_num_input" :placeholder="$t('message.strategyPushMgt.couponNameOrID')" />
                <a-col :span="2"></a-col>  
            </a-row>
            <a-row>
                <a-table row-key="coupon_id" :columns="couponNumColumns" :data-source="couponNumTableData"
                    :row-selection="{ selectedRowKeys: couponNumRowSelection, onChange: onSelectChangeCouponNum }"
                    bordered :pagination="numPagination">
                    <template slot="operation" slot-scope="text, record">
                        <a-input-number :size="$globalSize" v-model="record.num" :step="100" class="product-num" />
                        <a-select :size="$globalSize" v-model="record.data_type">
                            <a-select-option style="width:80px" v-for="item in unitOptions" :key="item.value" :value="item.value">{{item.name}}</a-select-option>
                        </a-select>
                    </template>
                </a-table>
            </a-row>
        </a-modal>

        <!-- 优惠券选择 -->
        <a-modal width="800px" :cancelText="$t('message.commonUsage.cancel')" :okText="$t('message.commonUsage.confirm')" v-model="couponBaseControl" :title="$t('message.strategyPushMgt.CouponSelection')" :maskClosable="false"
            @ok="couponBaseControlOk">
            <a-row>
                <a-col :span="2"></a-col>
                <span class="title-name">{{ $t('message.strategyPushMgt.QueryCoupons') }}: &nbsp;&nbsp;&nbsp;&nbsp;</span>
                <a-input-search class="search_input_style" v-model="search_coupon_input" :placeholder="$t('message.strategyPushMgt.searchNameOrID')" />
                <a-col :span="2"></a-col>  
            </a-row>
            <a-row>
                <a-table row-key="coupon_id" :pagination="numPagination" :columns="couponResultColumns" :data-source="couponTableData"
                    :row-selection="{ selectedRowKeys: couponBaseRowSelection, onChange: onSelectChangeCoupon }"
                    bordered>
                </a-table>
            </a-row>
        </a-modal>

        <!-- 保底优惠券为空提示 -->
        <a-modal width="600px" :cancelText="$t('message.commonUsage.cancel')" :okText="$t('message.commonUsage.confirm')" centered v-model="couponPromptVisible" :maskClosable="false" @ok="couponPromptOk">
            <template slot="title">
                <a-icon type="exclamation-circle" class="exclamation-circle"/>  {{ $t('message.strategyPushMgt.Tips') }}
            </template>
            <div class="prompt-text">不选择保底券，超出数量控制或者没有匹配到券的人员将会被过滤删除!</div>
        </a-modal>
    </div>
</template>
<script>
import CouponTag from "@/interface/pages/Coupon/Coupon"
import AiProduct from "@/interface/pages/AutoProduct/AutoProduct"
import launchStrategyService from "@/interface/pages/Strategy/launchStrategyService";
import utils from "@/utils";
import moment from 'moment';
export default {
    props: {
        // strategy_id: {
        //     type: String,
        //     default: ''
        // },
        strategy: {
            type: Object,
            default: {}
        }
    },
    name: 'SmartCoupon',
    data() {
        return {
            spinningProductPage: false,
            productsTypeList: [],
            importantOptions: [],
            categoryCoveredOptions: [],
            chiefAimOptions: [
                { value: 1, name: this.$t('message.strategyPushMgt.IncreaseSalesRevenue') },
                { value: 2, name: this.$t('message.strategyPushMgt.IncreaseProfitability') },
                { value: 3, name: this.$t('message.strategyPushMgt.IncreaseOrderVolume') },
            ],
            fixedPositionOptions: [
                { value: 1, name: '第一名' },
                { value: 2, name: '第二名' },
                { value: 3, name: '第三名' },
                { value: 4, name: '第四名' },
                { value: 5, name: '第五名' },
                { value: 6, name: '第六名' },
                { value: 7, name: '第七名' },
                { value: 8, name: '第八名' },
                { value: 9, name: '第九名' },
                { value: 10, name: '第十名' },
            ],
            promoteOptions: [
                { value: 1, name: '一名' },
                { value: 2, name: '二名' },
                { value: 3, name: '三名' },
                { value: 4, name: '四名' },
                { value: 5, name: '五名' }
            ],
            reduceOptions: [
                { value: -1, name: '一名' },
                { value: -2, name: '二名' },
                { value: -3, name: '三名' },
                { value: -4, name: '四名' },
                { value: -5, name: '五名' }
            ],
            // useScopeOptions: [
            //     { value: '1', name: '热门产品' },
            //     { value: '2', name: '与已购产品相似的产品' },
            //     { value: '3', name: '与已购产品搭配的产品' },
            //     { value: '4', name: '购买最多的产品' },
            // ],
            modifyOptions: [
                { value: 'move', name: this.$t('message.strategyPushMgt.FixedPosition') },
                // { value: 'add', name: '提升/降低' },
                { value: 'promote', name: this.$t('message.strategyPushMgt.Promote') },
                { value: 'reduce', name: this.$t('message.strategyPushMgt.Lower') },
                { value: 'del', name: this.$t('message.strategyPushMgt.Exclude') },
            ],
            unitOptions: [
                { value: '天', name: '天' },
                { value: '周', name: '周' },
                { value: '月', name: '月' },
            ],
            defaultautoProductTargetObj: {
                productType: [],
                important1: void 0,
                important2: void 0,
                important3: void 0,
                important4: void 0,
                categoryCovered1: [],
                categoryCovered2: [],
                categoryCovered3: [],
                categoryCovered4: [],
                chiefAim: void 0,
                otherAim: [],
                otherAimPush: void 0,
            },
            autoProductTargetObj: {
                productType: [],
                important1: void 0,
                important2: void 0,
                important3: void 0,
                important4: void 0,
                categoryCovered1: [],
                categoryCovered2: [],
                categoryCovered3: [],
                categoryCovered4: [],
                chiefAim: void 0,
                otherAim: [],
                otherAimPush: void 0,
                // aimScopeStart1: void 0,
                // aimScopeStart2: void 0,
                // aimScopeStart3: void 0,
                // aimScopeStart4: void 0,
                // aimScopeEnd1: void 0,
                // aimScopeEnd2: void 0,
                // aimScopeEnd3: void 0,
                // aimScopeEnd4: void 0,
            },
            disableContent1: true,
            disableContent2: true,
            disableContent3: true,
            disableContent4: true,
            autoCouponShow: true, //智能优惠券
            autoCouponShow2: false, // 产品页
            autoCouponShow3: false, // 周期投放页
            productAdjustObj: {
                search: '',// 搜索文字
                modifyRadio: void 0, // 修改内容
                fixedPosition: void 0, // 修改位置固定位置
                promotePosition: void 0, //
                reducePosition: void 0, //
                // modifyValue: null,// 变化值
                usedScope: [],// 使用范围
            },
            resultcolumnsProduct: [
                { dataIndex: 'level_3_code', key: 'level_3_code', title: this.$t('message.strategyPushMgt.ProductID'),width: 150 },
                { dataIndex: 'level_3_name', key: 'level_3_name', title: this.$t('message.strategyPushMgt.ProductName'),width: 150 },
                { dataIndex: 'content', key: 'content', title: this.$t('message.strategyPushMgt.AdjustContent'),width: 150 },
                { dataIndex: 'resource', key: 'resource', title: this.$t('message.strategyPushMgt.ApplicationScope'), ellipsis: true,width: 150 }
            ],
            resultcolumnsCoupon: [
                { dataIndex: 'coupon_name', key: 'name', title: this.$t('message.strategyPushMgt.CouponName'),width: 150 },
                { dataIndex: 'num', key: 'number', title: this.$t('message.strategyPushMgt.QuantityControl'), scopedSlots: { customRender: "number" },width: 150 },
            ],
            productColumns: [
                { dataIndex: 'level_3_code', key: 'level_3_code', title: this.$t('message.strategyPushMgt.ProductID') },
                { dataIndex: 'level_3_name', key: 'level_3_name', title: this.$t('message.strategyPushMgt.ProductName') }
            ],
            productData: [],
          
            productrowSelection: [],
            productSelectedRows: [],
            productResultData: [],
            dataTest: [{ name: '板烧鸡腿堡', content: '+5', resource: '所有产品选择来源', number: '50000张/每天' }],
            couponNumResultData: [],
            dataTest1: [{ name: '麦辣鸡腿堡', content: '提升100%', resource: '所有产品选择来源', number: '50000张/每天' }],
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px'
               
            },
            productRadioStyle: { display: 'block', height: '36px',lineHeight: '36px' },
            productShow: false,
            couponNumShow: false,
            open1: false,
            value: 1,
            couponNumColumns: [
                { dataIndex: 'coupon_id', key: 'id', title: this.$t('message.strategyPushMgt.CouponID') ,width: 300 },
                { dataIndex: 'coupon_name', key: 'name', title: this.$t('message.strategyPushMgt.CouponName') },
                { dataIndex: 'operation', key: '', width: 210,title: this.$t('message.strategyPushMgt.QuantityControl'), scopedSlots: { customRender: 'operation' }, }
            ],
            couponNumData: [],
            couponNumRowSelection: [],
            couponNumSelectedRows: [],
            couponBaseControl: false,
            couponColumns: [
                { dataIndex: 'id', key: 'id', title: this.$t('message.strategyPushMgt.CouponNumber') },
                { dataIndex: 'coupon_name', key: 'coupon_name', title: this.$t('message.strategyPushMgt.CouponName') },
            ],
            couponResultColumns: [
                { dataIndex: 'coupon_id', key: 'coupon_id', title: this.$t('message.strategyPushMgt.CouponNumber') ,width: 150 },
                { dataIndex: 'coupon_name', key: 'coupon_name', title: this.$t('message.strategyPushMgt.CouponName'),width: 150 },
            ],
            couponBaseResultData: [],
            couponBaseData: [ ],
        
            couponBaseRowSelection: [],
            couponBaseSelectionRow: [],
            productPage: { // 产品页的分页
                defaultPageSize: 3, //默认当前页数据量
                showTotal: (total) => `${this.$t('message.commonUsage.total')} ${total} ${this.$t('message.commonUsage.records')}`, //数据总量
                showSizeChanger: true, //显示当前页数据量改变
                pageSizeOptions: ["3","5"], //页容量显示
            },
            savaData: {}, // 智能优惠券保存到后台的数据
            numPagination: {
                defaultPageSize: 5, //默认当前页数据量
                showTotal: (total) => `${this.$t('message.commonUsage.total')} ${total} ${this.$t('message.commonUsage.records')}`, //数据总量
            },
            search_product_input: '',
            search_num_input: '',
            search_coupon_input: '',
            smallCouponObj: {},
            valueTime: undefined,
            loading_coupon: false,
            couponPromptVisible: false,
        }
    },
    computed: {
        productTableData() {
            const search = this.search_product_input
            if (search) {
                return this.productData.filter(data => {
                    let key_name = ['level_3_code','level_3_name']
                    return key_name.some(key => {
                        return String(data[key]).toLowerCase().indexOf(search.toLowerCase()) > -1
                    })
                })
            }
            return this.productData 
        },
        couponNumTableData() { // 优惠券数量控制:模糊搜索
            const search = this.search_num_input
            if (search) {
                return this.couponNumData.filter(data => {
                    let key_name = ['coupon_id','coupon_name']
                    return key_name.some(key => {
                        return String(data[key]).toLowerCase().indexOf(search.toLowerCase()) > -1
                    })
                })
            }
            return this.couponNumData
        },
        couponTableData() {
            const search = this.search_coupon_input
            if (search) {
                return this.couponBaseData.filter(data => {
                    let key_name = ['coupon_id','coupon_name']
                    return key_name.some(key => {
                        return String(data[key]).toLowerCase().indexOf(search.toLowerCase()) > -1
                    })
                })
            }
            return this.couponBaseData
        }
    },
    watch: {
        'autoProductTargetObj.productType' (val) {
            let totalIds = []
            this.productsTypeList.forEach(item => {
                const id = item.id
                totalIds.push(id)
                this['disableContent'+id] = true // 选项置灰
                // 没有选项都清空数据
                if(val.length === 0) {
                    this.autoProductTargetObj['important'+id] = void 0;
                    this.autoProductTargetObj['categoryCovered'+id] = [] 
                }
            })

            let ids = [] 
            val.forEach(item => {
                ids.push(item.id)
                this['disableContent'+item.id] = false // 选中的置灰取消
            })
            totalIds.forEach(tId => {
                if(!ids.includes(tId)) { // 没有中的清空数据
                    this.autoProductTargetObj['important'+tId] = void 0;
                    this.autoProductTargetObj['categoryCovered'+tId] = []  
                }   
            })
        }
    },
    created() {
        this.getAutoMeta()
        this.getProductLevel3List() 
        this.getCouponNumList()
        this.getCouponBaseList()
    },
    methods: {
        backToStrategy() {
            this.$emit('backToStrategy')
        },
        couponPromptOk() {
            this.couponPromptVisible = false
            // this.autoCouponShow2 = false
            // this.autoCouponShow3 = true
            this.createStrategy()
        },
        downloadTemplate() {
            window.open('/api/ai/exportCouponNumExcel','_blank')
        },
        customRequest(val) {
            this.spinningProductPage = true
            const fileFormData = new FormData()
            fileFormData.append('file', val.file)
            // fileFormData.append('strategy_id', this.strategy_id)
            CouponTag.uploadCouponNumExcel(this,{data: fileFormData}).then((response)=>{
                let res=response.data;
                if(res.code ==='200') {
                    const result = res.data
                    if(result.length > 0) {
                        this.couponNumResultData = result
                        const selectedKeys = []
                        // 更新 优惠券数量控制弹窗列表和导入一致
                        for (let index = 0; index < result.length; index++) {
                            const element = result[index];
                            selectedKeys.push(element.coupon_id)
                            this.couponNumTableData.forEach(item=>{
                                if(item.coupon_id === element.coupon_id) {
                                    item.data_type = element.data_type
                                    item.num = element.num
                                }
                            }) 
                        }
                        
                        this.couponNumRowSelection = selectedKeys
                        this.couponNumSelectedRows = result
                        this.smallCouponObj.autoCouponNumObj = result
                    }            
                    this.$message.success(res.message); 
                } else {
                    this.$message.error(res.message);
                }
            }).catch((error)=>{
                console.log("上传失败！" + error);
            }).finally(()=>{
                this.spinningProductPage = false
            })
        },
        onChangeTime(time, timeString) {
            if(time) {
                this.valueTime = moment(timeString,'HH:mm')
                this.smallCouponObj.pushTime = timeString + ":00";
            }else {
                this.valueTime = null
                this.smallCouponObj.pushTime = '';
            }
        },
        getAutoMeta(){
            CouponTag.getAutoMeta(this,{params:{}}).then((response)=>{
                let res = response.data;
                if(res.code === '200') {
                    this.productsTypeList = res.data.model_name
                    this.categoryCoveredOptions = res.data.food_type
                    this.importantOptions = res.data.rk
                } else {
                    this.productsTypeList = []
                    this.categoryCoveredOptions = []
                    this.importantOptions = []
                }
            }).catch((error)=>{
                console.log("查询失败！" + error);
            })
        },
        getCouponNumList() {
            CouponTag.getCouponNumList(this,{params:{}}).then((response)=>{
                let res = response.data;
                if(res.code === '200') {
                    this.couponNumData = res.data
                 
                } else {
                    this.couponNumData = []
                  
                }
            }).catch((error)=>{
                console.log("查询失败！" + error);
            })
        },
        getCouponBaseList() {
            CouponTag.getCouponBaseList(this,{params:{}}).then((response)=>{
                let res = response.data;
                if(res.code === '200') {
                    this.couponBaseData = res.data
                   
                } else {
                    this.couponBaseData = []
                  
                }
            }).catch((error)=>{
                console.log("查询失败！" + error);
            })
        },
        getProductLevel3List() {
            AiProduct.getProductLevel3List(this,{params:{}}).then((response)=>{
                let res = response.data;
                if(res.code === '200') {
                    this.productData = res.data
                 
                } else {
                    this.productData = []
                 
                }
            }).catch((error)=>{
                console.log("查询失败！" + error);
            })
        },
        couponNext2() {
            // 验证表单
            const productTypeList = this.autoProductTargetObj.productType // 产品选择来源 选择数据
            // if(productTypeList.length === 0) {
            //     return this.$message.warning('请选择产品选择来源！');
            // }

            if(productTypeList.length>0) {
                for(let i = 0;i < productTypeList.length;i++) {
                    const id = productTypeList[i].id
                    const importContent = this.autoProductTargetObj['important'+id]
                    const categoryCovered = this.autoProductTargetObj['categoryCovered'+id]
                    // if(importContent && categoryCovered.length > 0) {
                    if(importContent) {
                        console.log(id);
                    } else {
                        return this.$message.warning(this.$t('message.strategyManagement.SelectImportanceLevel'));
                    }
                    if(categoryCovered.length <= 0) {
                        return this.$message.warning(this.$t('message.strategyManagement.SelectCategory'));
                    }
                }
            }

            if (!this.autoProductTargetObj.chiefAim) {
                return this.$message.warning(this.$t('message.strategyPushMgt.SelectPrimaryTargets'));
            }
            
            if(this.autoProductTargetObj.otherAim.length > 0 && !this.autoProductTargetObj.otherAimPush) {
                if(this.autoProductTargetObj.otherAimPush === 0) {} else {
                    return this.$message.warning(this.$t('message.strategyPushMgt.EnterOtherTargets'));
                }
            }
            
            let arr = []
            productTypeList.forEach(item => {
                const id = item.id
                let obj = {}
                obj.modelName = item.key
                obj.rk = this.autoProductTargetObj['important'+id]
                obj.foodTypes = this.autoProductTargetObj['categoryCovered'+id]
                arr.push(obj)
            })
            this.smallCouponObj = {
                autoProductTargetObj: {},
                autoProductObj: [],
                autoCouponNumObj: [],
                autoCouponBaseObj: [],
                // pushTime: '',
                // strategy_id: this.strategy_id
            }
            this.smallCouponObj.autoProductTargetObj.productSelect = arr
            this.smallCouponObj.autoProductTargetObj.chiefAim = this.autoProductTargetObj.chiefAim
            let otherAim = this.autoProductTargetObj.otherAim
            if(otherAim.length>0) {
                this.smallCouponObj.autoProductTargetObj.otherAim = 'true'
                this.smallCouponObj.autoProductTargetObj.otherAimPush = this.autoProductTargetObj.otherAimPush
            } else {
                this.smallCouponObj.autoProductTargetObj.otherAim = 'false'
                this.smallCouponObj.autoProductTargetObj.otherAimPush = 0
            }
           
            this.autoCouponShow = false
            this.autoCouponShow2 = true
        },
        // couponNext3() {
        //     if(this.smallCouponObj.autoCouponBaseObj.length<=0) {
        //         // return this.$message.warning('保底优惠券不能为空！');
        //         this.couponPromptVisible = true
        //     } else {
        //         this.autoCouponShow2 = false
        //         this.autoCouponShow3 = true
        //     }
        // },
        // couponNext4() {
        //     this.autoCouponShow3 = false
        //     // if (this.action_type === 0) {
        //     //     this.$emit('smartNextStept', this.action_type)
        //     // }
        // },
        savaAutoCouponProductConfig() {
            // if(!this.smallCouponObj.pushTime) {
            //     return this.$message.warning('请填写时间！');
            // }
            if(this.smallCouponObj.autoCouponBaseObj.length<=0) {
                // return this.$message.warning('保底优惠券不能为空！');
                this.couponPromptVisible = true
            } else {
                this.createStrategy()
            }              
        },
        createStrategy() {
            let params = {
                strategyMain: this.strategy,
                type: 1,
                config: this.smallCouponObj
            }
            // 保存
            this.loading_coupon = true
            launchStrategyService.createStrategy(this, {data: params})
            .then((response) => {
                let res = response.data;
                if (res.code == 200) {
                    this.$message.success(res.message);
                    setTimeout(() => {
                        this.loading_coupon = false
                        this.autoCouponShow2 = false
                        this.$emit('destorySmallCoupon')
                        this.$emit('refreshStrategyTable')     
                    }, 1000);
                } else {
                    this.$message.error(res.message);
                }
            })
            .finally(()=>{
                this.loading_coupon = false
            })
        },
        handleCancel() {
            this.$emit('destorySmallCoupon')
            this.autoCouponShow = false
        },
        setModifyRadio(type) {
            const item = this.modifyOptions.filter(item=>item.value === type)
            if(item.length>0) {
                let name = item[0].name
                let result = ''
                if(this.productAdjustObj.modifyRadio === 'move') {
                    const fixedPosition = this.productAdjustObj.fixedPosition
                    const fixedPositionArr = this.fixedPositionOptions.filter(item =>item.value === fixedPosition)
                    result = name + '' + fixedPositionArr[0].name
                } else if(this.productAdjustObj.modifyRadio == 'promote') {
                    const promotePosition = this.productAdjustObj.promotePosition
                    const promotePositionArr = this.promoteOptions.filter(item =>item.value === promotePosition)
                    result = name + '' + promotePositionArr[0].name
                } else if(this.productAdjustObj.modifyRadio == 'reduce') {
                    const reducePosition = this.productAdjustObj.reducePosition
                    const reduceOptionsArr = this.reduceOptions.filter(item =>item.value === reducePosition)
                    result = name + '' + reduceOptionsArr[0].name
                }
                // else if(this.productAdjustObj.modifyRadio == 'add') {
                //     result = name + '' + this.productAdjustObj.modifyValue
                // } 
                else {
                    result = name
                }
                return result
            }else {
                return ''
            }
        },
        setUsedScope(value) {
            let name = []
            for (let index = 0; index < value.length; index++) {
                const element = value[index];
                this.productsTypeList.forEach(item=>{
                    if(element === item.key) {
                        name.push(item.value)
                    }
                })
            }
            if(name.length > 0) {
                return name.join(',');
            } else {
                return ''
            }
        },
        productAdjustOk() {
            // console.log(this.productSelectedRows);//勾选数据
            if(this.productSelectedRows.length > 0) {
                //产品调整:校验
                if(!this.productAdjustObj.modifyRadio) {
                    return this.$message.warning(this.$t('message.strategyPushMgt.SelectModifiedContent'));
                }
                // if(this.productAdjustObj.modifyRadio==='move'&& !this.productAdjustObj.fixedPosition) {
                //     return this.$message.warning('请选择固定位置！');
                // } else if (this.productAdjustObj.modifyRadio==='add'&& !this.productAdjustObj.modifyValue){
                //     return this.$message.warning('请填写提升/降低！');
                // }

                if(this.productAdjustObj.modifyRadio==='move'&& !this.productAdjustObj.fixedPosition) {
                    return this.$message.warning(this.$t('message.strategyPushMgt.SelectFixedPosition'));
                } else if (this.productAdjustObj.modifyRadio==='promote'&& !this.productAdjustObj.promotePosition){
                    return this.$message.warning(this.$t('message.strategyPushMgt.EnterPromotionInfo'));
                } else if (this.productAdjustObj.modifyRadio==='reduce'&& !this.productAdjustObj.reducePosition){
                    return this.$message.warning(this.$t('message.strategyPushMgt.FillDecreaseValue'));
                }

                if(this.productAdjustObj.usedScope.length===0) {
                    return this.$message.warning(this.$t('message.strategyPushMgt.SelectUsageRange'));
                }
                this.productResultData = utils.deepCopy(this.productSelectedRows)
                const modifyRadioStr = this.setModifyRadio(this.productAdjustObj.modifyRadio)
                const usedScopeStr = this.setUsedScope(this.productAdjustObj.usedScope)
                for (let i in this.productResultData) {
                    this.productResultData[i].content = modifyRadioStr;
                    this.productResultData[i].resource = usedScopeStr;
                }
                const params = {
                    content_type: this.productAdjustObj.modifyRadio,
                    content_num: null,
                    resource: this.productAdjustObj.usedScope
                }

                if(this.productAdjustObj.modifyRadio==='move') {
                    params.content_num = this.productAdjustObj.fixedPosition
                } else if(this.productAdjustObj.modifyRadio ==='promote') {
                    params.content_type ='add'
                    params.content_num = this.productAdjustObj.promotePosition
                } else if(this.productAdjustObj.modifyRadio ==='reduce') {
                    params.content_type ='add'
                    params.content_num = this.productAdjustObj.reducePosition
                }
                // else if (this.productAdjustObj.modifyRadio==='add'){
                //     params.content_num = this.productAdjustObj.modifyValue
                // }
                else {
                    params.content_num = null
                }
                let arr = utils.deepCopy(this.productSelectedRows)
                for (let index = 0; index < arr.length; index++) {
                    arr[index] = { ...arr[index], ...params };  
                }
                this.smallCouponObj.autoProductObj = arr
            } else {
                // 产品调整为空
                this.productResultData = utils.deepCopy(this.productSelectedRows)
                this.smallCouponObj.autoProductObj = []
            }
            this.productShow = false
        },
        // onProductAdjustSearch(val) {
        //     if(val) {
        //         const result = this.productData.filter(data => {
        //             return data.level_3_code.toString().toLowerCase().includes(val) || data.level_3_name.toString().toLowerCase().includes(val)
        //         })
        //         this.productData = result
        //     } else {
        //         this.productData =[]
        //     } 
        // },
        onSelectChangeProduct(selectedKeys,selectedRows) {
            this.productrowSelection = selectedKeys
            this.productSelectedRows = selectedRows
        },
        couponNumOk() {
           this.couponNumResultData = this.couponNumSelectedRows
           this.smallCouponObj.autoCouponNumObj = this.couponNumSelectedRows
           this.couponNumShow = false 
        },
        onSelectChangeCouponNum(selectedKeys,selectedRows) {
            this.couponNumRowSelection = selectedKeys
            this.couponNumSelectedRows = selectedRows
        },
        productControl() {
            this.productShow = true
        },
        productNumControl() {
            this.couponNumShow = true
        },
        couponBaseEdit() {
            this.couponBaseResultData = this.couponBaseSelectionRow
            this.couponBaseControl = true
        },
        couponBaseControlOk() {
            this.couponBaseResultData = this.couponBaseSelectionRow
            this.smallCouponObj.autoCouponBaseObj = this.couponBaseSelectionRow
            this.couponBaseControl = false
        },
        onSelectChangeCoupon(selectedKeys,selectedRows) {
            this.couponBaseRowSelection = selectedKeys
            this.couponBaseSelectionRow = selectedRows
        },
        productTypeChange(val) {console.log(val)},
        changeCategoryCovered(val,num) {
            // 全选暂时没有 取消方法
            // if(val.includes('all')) {
            //     this.autoProductTargetObj['categoryCovered'+num] = ['all']
            // }
        },
        otherAimChange(val) {
            if(val.length === 0) {
                this.autoProductTargetObj.otherAimPush = void 0
            } else if(val[0] === 2) {
                this.autoProductTargetObj.otherAimPush = 3
            }
        },
        addDate(days) {
            let date = new Date();
            date.setDate(date.getDate() + days);
            let month = date.getMonth() + 1;
            let day = date.getDate();
            return date.getFullYear() + '-' + this.getFormatDate(month) + '-' + this.getFormatDate(day);
        },
        getFormatDate(arg) {
            if (arg == undefined || arg == '') { return ''; }
            let re = arg + '';
            if (re.length < 2) { re = '0' + re; }
            return re;
        },
        forceUpdate() {
            this.$forceUpdate()
        },
    }
}
</script>
<style scoped lang="less">
.coupon-required-text {
    display: inline-block;
    color: #f5222d;
    width: 12px;
}
.edit-btn{
    margin-top: -4px;
}
.mr10 {
    margin-right: 6px;
}
.title-name {
    font-weight: bold;
    color: #000000;
}

.inline-block {
    display: flex;
}

.ant-checkbox-wrapper+.ant-checkbox-wrapper {
    margin-left: 0;
}

.product-num {
    margin-right: 4px;
}
.mt6 {
    margin-top: 6px;
}
.ml40 {
    margin-left: 40px
}
.pr20 {
    padding-right:20px
}
.search_input_style {
    width: 360px;
    margin-bottom:14px
}
.product-table ::v-deep .ant-empty-normal {
    margin: 0!important;
}
.mid > div{
    margin-bottom: 5px;
}
.modal-product {
    ::v-deep .ant-btn-primary:not([disabled]):hover,
    ::v-deep .ant-btn-primary:not([disabled]):focus {
    border-color: var(--main-color)!important;
  }
}
.prompt-text {
    font-size: 15px;
}
.exclamation-circle {
    color: var(--main-color);
}
</style>